import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['button', 'menu', 'chevron']

  toggle() {
    this.buttonTarget.setAttribute("aria-expanded", !(this.buttonTarget.getAttribute("aria-expanded") === "true"));
    this.menuTarget.classList.toggle("hidden")
    this.chevronTarget.classList.toggle("rotate-90")
  }

  hide(event) {
    if (!this.element.contains(event.target)) {
      this.buttonTarget.setAttribute("aria-expanded", false);
      this.menuTarget.classList.add("hidden")
    }
  }
}
